import React from "react";
import theme from "app/Theme/Theme";
import Svg, { ClipPath, Defs, G, Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const TeamIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
    {...props}
    fill="none"
  >
    <Path
      d="M14.5 6.5C14.5 7.16304 14.2366 7.79893 13.7678 8.26777C13.2989 8.73661 12.663 9 12 9C11.337 9 10.7011 8.73661 10.2322 8.26777C9.76339 7.79893 9.5 7.16304 9.5 6.5C9.5 5.83696 9.76339 5.20107 10.2322 4.73223C10.7011 4.26339 11.337 4 12 4C12.663 4 13.2989 4.26339 13.7678 4.73223C14.2366 5.20107 14.5 5.83696 14.5 6.5ZM19.5 7C19.5 7.53043 19.2893 8.03914 18.9142 8.41421C18.5391 8.78929 18.0304 9 17.5 9C16.9696 9 16.4609 8.78929 16.0858 8.41421C15.7107 8.03914 15.5 7.53043 15.5 7C15.5 6.46957 15.7107 5.96086 16.0858 5.58579C16.4609 5.21071 16.9696 5 17.5 5C18.0304 5 18.5391 5.21071 18.9142 5.58579C19.2893 5.96086 19.5 6.46957 19.5 7ZM6.5 9C7.03043 9 7.53914 8.78929 7.91421 8.41421C8.28929 8.03914 8.5 7.53043 8.5 7C8.5 6.46957 8.28929 5.96086 7.91421 5.58579C7.53914 5.21071 7.03043 5 6.5 5C5.96957 5 5.46086 5.21071 5.08579 5.58579C4.71071 5.96086 4.5 6.46957 4.5 7C4.5 7.53043 4.71071 8.03914 5.08579 8.41421C5.46086 8.78929 5.96957 9 6.5 9ZM8 11.25C8 10.56 8.56 10 9.25 10H14.75C15.44 10 16 10.56 16 11.25V16C16 17.0609 15.5786 18.0783 14.8284 18.8284C14.0783 19.5786 13.0609 20 12 20C10.9391 20 9.92172 19.5786 9.17157 18.8284C8.42143 18.0783 8 17.0609 8 16V11.25ZM7 11.25C7 10.787 7.14 10.358 7.379 10H5.25C4.56 10 4 10.56 4 11.25V15C3.99995 15.4281 4.09154 15.8513 4.2686 16.2411C4.44566 16.6309 4.7041 16.9782 5.02655 17.2599C5.34901 17.5415 5.728 17.7508 6.13807 17.8738C6.54813 17.9968 6.97978 18.0307 7.404 17.973C7.13645 17.3497 6.99898 16.6783 7 16V11.25ZM17 16C17 16.7 16.856 17.368 16.596 17.973C17.0202 18.0307 17.4519 17.9968 17.8619 17.8738C18.272 17.7508 18.651 17.5415 18.9734 17.2599C19.2959 16.9782 19.5543 16.6309 19.7314 16.2411C19.9085 15.8513 20 15.4281 20 15V11.25C20 10.56 19.44 10 18.75 10H16.621C16.861 10.358 17 10.787 17 11.25V16Z"
      fill={color}
    />
  </Svg>
);

export default TeamIcon;
